import React, { Component } from "react";
import Translation from "../translation/translation";
import { Link, Redirect } from "react-router-dom";
//import $ from 'jquery';
import Context from "../context/context";
import Comm from "../comm/comm";

class ContragentsMenu extends Component {
    constructor() {
        super();
        if (!Comm.ValidSession()) return;

        this.state = {
            Translation: Translation,
        };
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }

        return (
            <div className="btn-toolbar">
                <Link className="btn btn-primary menuButton" to="/companydata">
                    <i className="fas fa-building"></i>
                    <p>{Translation.Trans("companydata")}</p>
                </Link>
                <Link className="btn btn-primary menuButton" to="/accounts">
                    <i className="fa fa-university"></i>
                    <p>{Translation.Trans("accounts")}</p>
                </Link>
                <Link className="btn btn-primary menuButton" to="/barcodes">
                    <i className="fa fa-barcode"></i>
                    <p>{Translation.Trans("barcodes")}</p>
                </Link>
                <Link className="btn btn-primary menuButton" to="/sales">
                    <i className="far fa-money-bill-alt"></i>
                    <p>{Translation.Trans("sales")}</p>
                </Link>
                <Link className="btn btn-primary menuButton" to="/invoices">
                    <i className="far fa-file-alt"></i>
                    <p>{Translation.Trans("invoicesexport")}</p>
                </Link>
                <Link className="btn btn-primary menuButton" to="/deliveries/false">
                    <i className="fas fa-truck"></i>
                    <p>{Translation.Trans("deliveries")}</p>
                </Link>
                <Link className="btn btn-primary menuButton" to="/deliveries/true">
                    <i className="fas fa-truck"></i>
                    <p>{Translation.Trans("deliveriesonroad")}</p>
                </Link>
                <Link className="btn btn-primary menuButton" to="/ontheway">
                    <i className="fas fa-truck"></i>
                    <p>{Translation.Trans("onroad")}</p>
                </Link>
                <Link className="btn btn-primary menuButton" to="/editdeliveries">
                    <i className="fas fa-truck"></i>
                    <p>{Translation.Trans("editdeliveries")}</p>
                </Link>
                <Link className="btn btn-primary menuButton" to="/editsales">
                    <i className="far fa-money-bill-alt"></i>
                    <p>{Translation.Trans("editsales")}</p>
                </Link>
                <Link className="btn btn-primary menuButton" to="/contragents">
                    <i className="fa fa-th"></i>
                    <p>{Translation.Trans("contragents")}</p>
                </Link>
                {Context.HasRight("rtax") && (
                    <Link className="btn btn-primary menuButton" to="/invoicesimport">
                        <i className="far fa-file-alt"></i>
                        <p>{Translation.Trans("invoices")}</p>
                    </Link>
                )}
                <Link className="btn btn-primary menuButton" to="/payments">
                    <i className="fa fa-credit-card" aria-hidden="true"></i>
                    <p>{Translation.Trans("payments")}</p>
                </Link>
            </div>
        );
    }
}

export default ContragentsMenu;



// WEBPACK FOOTER //
// ./src/pages/contragentsmenu.js